"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDispatcher = void 0;
var EventDispatcher = (function () {
    function EventDispatcher() {
        this.listeners = [];
    }
    EventDispatcher.prototype.addListener = function (listener) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item === listener) {
                return;
            }
        }
        this.listeners.push(listener);
    };
    EventDispatcher.prototype.removeListener = function (listener) {
        for (var i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i] === listener) {
                this.listeners.splice(i, 1);
                return;
            }
        }
    };
    EventDispatcher.prototype.dispatch = function (event) {
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var item = _a[_i];
            item(event);
        }
    };
    return EventDispatcher;
}());
exports.EventDispatcher = EventDispatcher;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnREaXNwYXRjaGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2dhdGUvRXZlbnREaXNwYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBO0lBQUE7UUFDWSxjQUFTLEdBQWUsRUFBRSxDQUFBO0lBMEJ0QyxDQUFDO0lBeEJVLHFDQUFXLEdBQWxCLFVBQW1CLFFBQWtCO1FBQ2pDLEtBQWlCLFVBQWMsRUFBZCxLQUFBLElBQUksQ0FBQyxTQUFTLEVBQWQsY0FBYyxFQUFkLElBQWMsRUFBRTtZQUE1QixJQUFJLElBQUksU0FBQTtZQUNULElBQUksSUFBSSxLQUFLLFFBQVEsRUFBRTtnQkFDbkIsT0FBTTthQUNUO1NBQ0o7UUFFRCxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTtJQUNqQyxDQUFDO0lBRU0sd0NBQWMsR0FBckIsVUFBc0IsUUFBa0I7UUFDcEMsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQzVDLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSyxRQUFRLEVBQUU7Z0JBQ2hDLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtnQkFDM0IsT0FBTTthQUNUO1NBQ0o7SUFDTCxDQUFDO0lBRU0sa0NBQVEsR0FBZixVQUFnQixLQUFXO1FBQ3ZCLEtBQWlCLFVBQWMsRUFBZCxLQUFBLElBQUksQ0FBQyxTQUFTLEVBQWQsY0FBYyxFQUFkLElBQWMsRUFBRTtZQUE1QixJQUFJLElBQUksU0FBQTtZQUNULElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtTQUNkO0lBQ0wsQ0FBQztJQUNMLHNCQUFDO0FBQUQsQ0FBQyxBQTNCRCxJQTJCQztBQTNCWSwwQ0FBZSJ9